<template>
  <div class="white-container">
    <el-card class="white-box" v-loading="loading">
      <div slot="header">
        <span class="title" @click="handleQuery">IP白名单（对其他系统开放的接口(/bridge/XXX/XXX)需要IP验证）</span>
      </div>
      <el-input v-for="(item,i) in whiteList" v-model="whiteList[i]" :key="i" class="interval"></el-input>
      <el-button type="primary" @click="saveWhite">保存</el-button>
      <el-button type="primary" @click="add">新增</el-button>
    </el-card>
  </div>

</template>

<script>
import {getWhiteList, saveWhite} from '@/api/dingTalk'

export default {
  name: 'whiteList',
  data() {
    return {
      loading: false,
      params: {
        param_key: "ip_white_list",
        param_value: []
      },
      whiteList: []
    }
  },
  methods: {
    handleQuery(){
      this.getWhiteList(this.params)
    },

    //获取白名单列表
    getWhiteList(data) {
      this.loading = true
      getWhiteList(data).then(res => {
        this.loading = false
        this.whiteList = JSON.parse(res.data.param_value)
        let list = []
        this.whiteList.map(value => {
          if (value) {
            list.push(value)
          }
        })
        this.whiteList = list
      })
    },

    //保存
    saveWhite() {
      this.params.param_value = this.whiteList
      saveWhite(this.params).then(res => {
        if (!res.success) {
          return this.$message.error('修改配置失败')
        }
        this.$message.success('修改配置成功')
        this.getWhiteList(this.params)
      })
    },
    //添加ip地址
    add() {
      this.whiteList.push('')
    }
  },
  created() {
   this.handleQuery()
  },
}
</script>

<style scoped>
.white-container {
  margin: 20px;
  padding: 20px;
}

.white-box {
  width: 500px;
  min-height: 500px;
}

.ip-box {
  width: 80px;
  height: 30px;
}

.interval {
  margin-bottom: 15px;
}
</style>